import { render, staticRenderFns } from "./business.vue?vue&type=template&id=2d64a3f2&scoped=true&"
import script from "./business.js?vue&type=script&lang=js&"
export * from "./business.js?vue&type=script&lang=js&"
import style0 from "./business.scss?vue&type=style&index=0&id=2d64a3f2&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64a3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d64a3f2')) {
      api.createRecord('2d64a3f2', component.options)
    } else {
      api.reload('2d64a3f2', component.options)
    }
    module.hot.accept("./business.vue?vue&type=template&id=2d64a3f2&scoped=true&", function () {
      api.rerender('2d64a3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/century-rongtai/index/component/business/business.vue"
export default component.exports